import React from 'react';
import PropTypes from 'prop-types';
import {Alert} from "react-bootstrap";

/** @type {('primary'|'secondary'|'success'|'danger'|'warning'|'info'|'dark'|'light')} */
const VARIANTS = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light'];

/**
 * @param {Object} props
 * @param {string|React.ReactNode} props.message
 * @param {'primary'|'secondary'|'success'|'danger'|'warning'|'info'|'dark'|'light'} [props.variant]
 */
export default function Notification({message, variant = 'info'}) {
    return (
        <Alert variant={variant}>
            <p style={{fontSize: "1.5rem"}}>{message}</p>
        </Alert>
    );
}

Notification.propTypes = {
    // PropTypes.node is used to accept messages like this: <>Veuillez contacter <strong>l'administration</strong></>
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    variant: PropTypes.oneOf(VARIANTS),
};


